import { tw } from "~/utils";

interface PageButtonsProps {
  currentPage: number;
  numPages: number;
  setPage: (p: number) => void;
}

const getNumberList = (
  sentinel: number,
  currentPage: number,
  numPages: number,
) => {
  if (numPages <= 5) {
    return [...Array(numPages).keys()].map((k) => k + 1);
  }

  if ([1, 2, numPages - 1, numPages].includes(currentPage)) {
    return [1, 2, sentinel, numPages - 1, numPages];
  }

  if (currentPage === 3) {
    return [1, 2, 3, sentinel, numPages - 1, numPages];
  }

  if (currentPage === numPages - 2) {
    return [1, 2, sentinel, numPages - 2, numPages - 1, numPages];
  }

  return [1, 2, sentinel, currentPage, sentinel, numPages - 1, numPages];
};

export const PageButtons = ({
  currentPage,
  numPages,
  setPage,
}: PageButtonsProps) => {
  // Sentinel is mapped to "..." instead of a button
  const sentinel = 0;
  const pageNumbers = getNumberList(sentinel, currentPage, numPages);

  return (
    <ul className="flex flex-row gap-2">
      {pageNumbers.map((num, index) => (
        <li key={`${num}-${index}`} aria-current={currentPage === num}>
          {num === sentinel ? (
            <span className="flex size-8 items-center justify-center text-center hover:cursor-default">
              ...
            </span>
          ) : (
            <button
              onClick={() => setPage(num)}
              className={tw(
                "size-8 cursor-pointer rounded-sm",
                currentPage === num
                  ? "bg-light-lavender-gray cursor-default text-black"
                  : "hover:bg-light-lavender-gray/30",
              )}
            >
              {num}
            </button>
          )}
        </li>
      ))}
    </ul>
  );
};
